module.exports = __webpack_public_path__ + "static/media/Hbook.eebc5185.jpg";